import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Tooltip, Input, Row, Col, Button, Alert} from "reactstrap";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import classnames from "classnames";
import ReactDOM from "react-dom";
import scrollToComponent from "react-scroll-to-component";
import {setSurveyNavVisibility} from "reducers/surveyNav/actions";
import Scroll from "react-scroll";
import MobileMatrix from "../../Components/matrix/mobileMatrix";

class PresentationCarousel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openValidation: false,
      ended: false,
      rowTooltipOpen: false,
      columnTooltipOpen: false,
      currentIndex: 0,
      changingStatement: false,
      contentRow: {},
      contentColumn: {},
    };

    this.updateCurrentDetailContent = this.updateCurrentDetailContent.bind(this);
    this.handlerChangeContentRow = this.handlerChangeContentRow.bind(this);
    this.handlerChangeContentColumn = this.handlerChangeContentColumn.bind(this);
    this.incrementCurrentIndex = this.incrementCurrentIndex.bind(this);
    this.decrementCurrentIndex = this.decrementCurrentIndex.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.isTooltipOpen = this.isTooltipOpen.bind(this);
    this.nextItem = this.nextItem.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.columnCountRequirements = this.columnCountRequirements.bind(this);
    this.onChangeContentColumn = this.onChangeContentColumn.bind(this)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {ended} = this.state;
  }

  handlerChangeContentColumn(column, text){
    let {contentColumn} = this.state;

    contentColumn = {
      ...contentColumn,
      [column]: text
    };

    this.setState({
      contentColumn
    }, () => this.updateCurrentDetailContent());
  }

  handlerChangeContentRow(row, text){
    let {contentRow} = this.state;

    contentRow = {
      ...contentRow,
      [row]: text
    };

    this.setState({
      contentRow
    }, () => this.updateCurrentDetailContent());
  }

  updateCurrentDetailContent(){
    const currentRow = this.props.question.rows[this.state.currentIndex];
    const currentRowDetails = currentRow ? this.props.details.filter(detail => detail.row === currentRow.id) : false;

    let currentRowDetail = false;
    if(currentRowDetails){
      currentRowDetail = currentRowDetails[0];
    }

    if(currentRowDetail){
      if(this.state.contentRow[currentRowDetail.row]){
        currentRowDetail.contentRow = this.state.contentRow[currentRowDetail.row]
      }
      if(this.state.contentColumn[currentRowDetail.column]){
        currentRowDetail.contentColumn = this.state.contentColumn[currentRowDetail.column]
      }

      let filteredDetails = this.props.details.filter(detail => detail.row !== currentRow.id);
      this.props.onDetailsUpdated([...filteredDetails, currentRowDetail]);
    }
  }

  toggleTooltip(value, type) {
    if (this.state[type] === value) {
      this.setState({[type]: false});
    }else{
      this.setState({[type]: value});
    }
  }

  isTooltipOpen(value, type) {
    return this.state[type] === value;
  }

  incrementCurrentIndex(){
    this.nextItem();
  }

  decrementCurrentIndex(){
    const {currentIndex} = this.state;
    const {question} = this.props;

    this.setState({
      changingStatement: true
    });

    if(Object.keys(question.rows).indexOf((currentIndex-1).toString()) > -1){
      setTimeout(() => {
        this.setState({
          currentIndex: currentIndex-1,
          changingStatement: false,
        });
      }, 500)
    }else{
      setTimeout(() => this.props.changePage(1), 1)
    }
  }

  onItemClick(row, column) {
    let {question, details} = this.props;

    const microTime = getCurrentMicroTime(this.props.startTime);
    if (!details.find(detail => detail.row === row.id)) {
      this.props.onDetailsUpdated([...details, {row: row.id, column: column.id, microTime}]);
    } else {
      let filteredDetails = details.filter(detail => detail.row !== row.id);
      this.props.onDetailsUpdated([...filteredDetails, {row: row.id, column: column.id, microTime}]);
    }

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (row, column) { " + javascript.code + " }")().bind(this);
        func(row, column);
      }
    });
  }

  nextItem(){
    let {question, details} = this.props;
    const {currentIndex} = this.state;
    const currentRow = question.rows[currentIndex];
    const currentRowDetails = currentRow ? details.filter(detail => detail.row === currentRow.id) : false;

    if (currentRow.isOpen && currentRow.openIsRequired && (!currentRowDetails || !currentRowDetails[0].contentRow)) {
      this.setState({
        openValidation: true
      });
      return;
    }

    this.setState({
      openValidation: false,
      changingStatement: true,
      contentRow: {},
      contentColumn: {},
    });

    if((currentIndex+2) <= question.rows.length){
      this.setState({
        currentIndex: currentIndex+1,
      });

      Scroll.animateScroll.scrollTo(100, {
        duration: 600
      });

      setTimeout(() => {
        this.setState({
          changingStatement: false,
        });
      }, 500);
    }else{
      if (question.goToNextOnFill) {
        setTimeout(() => {
          this.props.setSurveyNavVisibility(true);
          if (this.props.isLastOnPage) {
            this.props.changePage(1);
          } else {
            const rects = ReactDOM.findDOMNode(this).getBoundingClientRect();
            scrollToComponent(this, {align: 'top', offset: rects.height + 40});
          }
        }, 1)
      }else{
        this.setState({
          ended: true,
        });
        this.props.setSurveyNavVisibility(true);
      }
    }
  }

  columnCountRequirements(column) {
    const {question, details} = this.props;
    let columnMin = question.transposed ? (question.requiredRows ? 1 : 0) : (question.requiredColumns ? 1 : 0);

    if (column.blocking && columnMin === 0) {
      columnMin = 1;
    }

    if (column.excludeRequired) {
      return false;
    }

    if (columnMin) {
      if (question.transposed) {
        if (details.filter(detail => detail.row === column.id).length < columnMin) {
          return true;
        }
      } else {
        if (details.filter(detail => detail.column === column.id).length < columnMin) {
          return true;
        }
      }
    }

    return false;
  }

  onChangeContentColumn(columnId, value, rowId){
    const {question, details} = this.props;
    const currentRow = question.rows.find((row) => row.id === rowId)

    const updated = details.map(detail => {
      if(detail.row === currentRow.id && detail.column === columnId){
        detail.contentColumn = value;
      }

      return detail;
    });

    this.props.onDetailsUpdated(updated);
  }

  render() {
    const {question, details, validated, validationTexts, questionResponse, contentRow} = this.props;
    const {changingStatement, currentIndex, contentColumn} = this.state;
    const currentRow = question.rows[this.state.currentIndex];
    const currentRowDetails = currentRow && details ? details.filter(detail => detail === currentRow.id) : false;

    let openStyle = {};
    if(currentRow && this.state.openValidation && (!currentRowDetails || !currentRowDetails[0].contentRow)){
      openStyle.borderWidth = '2px';
    }

    let rowStyle = {};
    if (changingStatement) {
      rowStyle.visibility = 'hidden';
    }

    let isColumnError = false;
    const columns = question.transposed ? question.rows : question.columns;
    _.map(columns, (column, index) => {
      if (this.columnCountRequirements(column)) {
        isColumnError = true;
      }
    });

    return (
      <MobileMatrix
        question={question}
        contentRow={contentRow}
        contentColumn={contentColumn}
          validationTexts={validationTexts}
        onChangeContentColumn={this.onChangeContentColumn}
        onChangeContentRow={this.props.onChangeContentRow}
        getAnswerLabel={this.getAnswerLabel}
        onItemClick={this.onItemClick}
          isColumnError={isColumnError && !questionResponse.excluding}
        details={details}
        validated={validated}
          questionResponse={questionResponse}
      />
    );
  }
}

PresentationCarousel.propTypes = {
  onDetailsUpdated: PropTypes.func.isRequired,
  onChangeContentColumn: PropTypes.func.isRequired,
  onChangeContentRow: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  contentRow: PropTypes.object,
  contentColumn: PropTypes.object,
  isLastOnPage: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state, props) => {
  return {
    survey: state.survey,
    startTime: state.timeMeasuring.startTime,
    questionResponse: state.questionResponses[props.question.id],
    surveyResponse: state.surveyResponse,
  }
}, {setSurveyNavVisibility}, null, {withRef: true})(PresentationCarousel);
